'use strict';
import * as $j_java$002elang$002e$002dObject from "./java.lang.-Object.js";
var $p;
/** @constructor */
function $c_Lsamples_EnumSample$package$Cat$1(name, weight, kind, color, mealId) {
  this.sy = null;
  this.sz = 0;
  this.sw = false;
  this.sv = null;
  this.sx = null;
  this.sy = name;
  this.sz = weight;
  this.sw = kind;
  this.sv = color;
  this.sx = mealId;
}
export { $c_Lsamples_EnumSample$package$Cat$1 as $c_Lsamples_EnumSample$package$Cat$1 };
$p = $c_Lsamples_EnumSample$package$Cat$1.prototype = new $j_java$002elang$002e$002dObject.$h_O();
$p.constructor = $c_Lsamples_EnumSample$package$Cat$1;
/** @constructor */
function $h_Lsamples_EnumSample$package$Cat$1() {
}
export { $h_Lsamples_EnumSample$package$Cat$1 as $h_Lsamples_EnumSample$package$Cat$1 };
$h_Lsamples_EnumSample$package$Cat$1.prototype = $p;
$p.I = (function() {
  return new $j_java$002elang$002e$002dObject.$c_s_Product$$anon$1(this);
});
$p.m = (function() {
  var acc = (-889275714);
  acc = $j_java$002elang$002e$002dObject.$m_sr_Statics$().t(acc, 67510);
  acc = $j_java$002elang$002e$002dObject.$m_sr_Statics$().t(acc, $j_java$002elang$002e$002dObject.$m_sr_Statics$().D(this.sy));
  acc = $j_java$002elang$002e$002dObject.$m_sr_Statics$().t(acc, this.sz);
  acc = $j_java$002elang$002e$002dObject.$m_sr_Statics$().t(acc, (this.sw ? 1231 : 1237));
  acc = $j_java$002elang$002e$002dObject.$m_sr_Statics$().t(acc, $j_java$002elang$002e$002dObject.$m_sr_Statics$().D(this.sv));
  acc = $j_java$002elang$002e$002dObject.$m_sr_Statics$().t(acc, $j_java$002elang$002e$002dObject.$m_sr_Statics$().D(this.sx));
  return $j_java$002elang$002e$002dObject.$m_sr_Statics$().an(acc, 5);
});
$p.f = (function(x$0) {
  if ((this === x$0)) {
    return true;
  } else if ((x$0 instanceof $c_Lsamples_EnumSample$package$Cat$1)) {
    if ((((this.sw === x$0.sw) && (this.sy === x$0.sy)) && (this.sz === x$0.sz))) {
      var x = this.sv;
      var x$2 = x$0.sv;
      var $x_1 = ((x === null) ? (x$2 === null) : (x === x$2));
    } else {
      var $x_1 = false;
    }
    if ($x_1) {
      var x$3 = this.sx;
      var x$4 = x$0.sx;
      return ((x$3 === null) ? (x$4 === null) : x$3.f(x$4));
    } else {
      return false;
    }
  } else {
    return false;
  }
});
$p.b = (function() {
  return $j_java$002elang$002e$002dObject.$m_sr_ScalaRunTime$().ah(this);
});
$p.n = (function() {
  return 5;
});
$p.o = (function() {
  return "Cat";
});
$p.g = (function(n) {
  switch (n) {
    case 0: {
      return this.sy;
      break;
    }
    case 1: {
      return this.sz;
      break;
    }
    case 2: {
      return this.sw;
      break;
    }
    case 3: {
      return this.sv;
      break;
    }
    case 4: {
      return this.sx;
      break;
    }
    default: {
      throw $j_java$002elang$002e$002dObject.$ct_jl_IndexOutOfBoundsException__I__(new $j_java$002elang$002e$002dObject.$c_jl_IndexOutOfBoundsException(), n);
    }
  }
});
function $isArrayOf_Lsamples_EnumSample$package$Cat$1(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.D === depth)) && obj.$classData.B.n.ee)));
}
export { $isArrayOf_Lsamples_EnumSample$package$Cat$1 as $isArrayOf_Lsamples_EnumSample$package$Cat$1 };
var $d_Lsamples_EnumSample$package$Cat$1 = new $j_java$002elang$002e$002dObject.$TypeData().i($c_Lsamples_EnumSample$package$Cat$1, "samples.EnumSample$package$Cat$1", ({
  ee: 1,
  b: 1,
  c: 1,
  a: 1
}));
export { $d_Lsamples_EnumSample$package$Cat$1 as $d_Lsamples_EnumSample$package$Cat$1 };
